export class VideoMonoStream {
  constructor (originalStream) {
    this.originalStream = originalStream

    this.audioContext = undefined
    this.audioSource = undefined
    this.audioMerger = undefined
    this.audioDestination = undefined
  }

  getStream () {
    const channelCount = this.originalStream.getAudioTracks()[0].getSettings().channelCount || 1

    if (channelCount === 1) {
      return this.originalStream
    }

    this.audioContext = new AudioContext()

    this.audioSource = this.audioContext.createMediaStreamSource(this.originalStream)
    this.audioMerger = this.audioContext.createChannelMerger(1)
    this.audioSource.connect(this.audioMerger)

    // Create a destination to output the processed audio
    this.audioDestination = this.audioContext.createMediaStreamDestination()
    this.audioMerger.connect(this.audioDestination)

    const processedStream = new MediaStream()

    this.originalStream.getVideoTracks().forEach((videoTrack) => {
      processedStream.addTrack(videoTrack)
    })

    this.audioDestination.stream.getAudioTracks().forEach((audioTrack) => {
      processedStream.addTrack(audioTrack)
    })

    return processedStream
  }

  async stop () {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => {
        track.stop()
      })
      this.stream = undefined
    }

    if (this.audioContext) {
      await this.audioContext.close()
      this.audioContext = undefined
    }

    if (this.audioSource) {
      this.audioSource.disconnect()
      this.audioSource = undefined
    }

    if (this.audioDestination) {
      this.audioDestination.disconnect()
      this.audioDestination = undefined
    }

    if (this.audioMerger) {
      this.audioMerger.disconnect()
      this.audioMerger = undefined
    }
  }
}
